'use strict';

class CtaHeroBlock {
    constructor() {
        const ctaHeroItems = document.querySelectorAll('.cta-hero');

        for (var i = 0; i < ctaHeroItems.length; i++) {
            const item = ctaHeroItems[i];
            const observer = new IntersectionObserver(this.handleIntersection);
            observer.observe(item);
        }
    }

    handleIntersection(entries) {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                if (entry.target && !entry.target.classList.contains('cta-hero--visible')) {
                    entry.target.classList.add('cta-hero--visible')
                }
            }
        });
    }

}
document.addEventListener("DOMContentLoaded", function () {
    new CtaHeroBlock();
});